import { Plugin } from '../../types';
import {loadConfig} from '../../config';
import {isSimilarUrl} from '../../utils/isSimilarUrl'
const config =  loadConfig()
const navigationConfig = config.actions && config.actions.navigation 
const delay = (t = 200) => new Promise((r) => setTimeout(() => r(), t));

export const navigation: Plugin = {
  name: 'navigation',
  page(emit){
    setInterval(
      ()=>{
        if(window.location.pathname === 'blank'){
          return
        }
        if(localStorage.getItem('_qali_href') === window.location.href){
          return 
        }
        localStorage.setItem('_qali_href',  window.location.href)
        emit({
          name: 'navigation',
          type: "navigate",
          value: window.location.pathname,
          time: Date.now() - 10
        })
      },10)
  },
  host: async (page, emit, context) => {
    const cdpSession = await context.newCDPSession(page)

    let lastHistoryIndex = 0
    let lastHistoryEntriesLength = 0
    page.on("framenavigated", async (frame) => {
      // Only consider the top frame window
      if (frame.parentFrame() !== null) {
        return
      }
      const now = Date.now()
      const history = await cdpSession.send("Page.getNavigationHistory")
      /**
       * We only want to track new 'goto' events if the user has actually typed in something and the
       * size of the history will increase if so.
       */
      if (lastHistoryEntriesLength === history.entries.length && history.currentIndex < lastHistoryIndex) {
          emit({
            name: 'navigation',
            type: "goback",
            value: frame.url(),
            time: now

          })
      }
      lastHistoryIndex = history.currentIndex
      lastHistoryEntriesLength = history.entries.length
    })
  },
  test:{
    matchers: {
      toHaveSimilarURL: async (page, url) => {
        await delay(300)
        let currentUrl = ''
        try{
          currentUrl = await page.evaluate('document.location.pathname')
        }catch(err){
          return { pass: true, message: () => "Page has similar url to " + url };
        }
        if(isSimilarUrl(url, currentUrl, navigationConfig)){
          return { pass: true, message: () => "Page has similar url to " + url };
        }
        try{
          await page.waitForNavigation({ timeout: 4000})
        }catch(err){}
        currentUrl = await page.evaluate('document.location.pathname')
        if(url === new URL(page.url()).pathname || isSimilarUrl(url, currentUrl, navigationConfig)){
          return { pass: true, message: () => "Page has similar url to " + url };
        }
        if(page.openNavigations.length){
          while(page.openNavigations.length){
            await delay(50)
          }
        }
        const pathIndex = page.pageHistory.indexOf(url)
        if(pathIndex !== -1){
          page.pageHistory.splice(pathIndex, 1)
          return { pass: true, message: () => "Page has similar url to " + url };
        }
        const pageIndex = page.pageHistory.findIndex((entry) => {
          if (isSimilarUrl(entry, url, navigationConfig as any)) {
            return true
          }
          return false
        })
        if (pageIndex !== -1) {
          page.pageHistory.splice(pageIndex, 1)
          return { pass: true, message: () => "Page has similar url to " + url };
        } else {
          if (isSimilarUrl(url, new URL(page.url()).pathname, navigationConfig as any)) {
            return { pass: true, message: () => "Page has similar url to " + url };
          }
        }
        return {
          pass: false,
          message: () => "Page does not have similar url to " + url,
        };
      },
    },
    hook: {
      beforeAll: async (page)=>{
        page.pageHistory = [];
        page.openNavigations = [];
        page.on('request', async (request)=>{
          if (request.isNavigationRequest()){
            page.openNavigations.push(request.url())
          }
        })
        
        page.on("framenavigated",  async (frame) => {
          page.openNavigations.splice(page.openNavigations.indexOf(frame.url()), 1)
          page.pageHistory.push(new URL(frame.url()).pathname);
        });
      }
    }
  },
  generate(event) {
    if(event.type === 'goback'){
      return `
      it("clicks the back button to go to path \`${event.value}\`", async () => {
        await page.goBack()
        await expect(page).toHaveSimilarURL("${event.value}")
      })`
    }else if(event.type === 'goto'){
      return `
      it("goes to a url path similar to \`${event.value}\`", async () => {
        await page.goto('${event.value}')
      })`
    }else if(event.type === 'navigate'){
      return `
      it("navigates to a url path similar to \`${event.value}\`", async () => {
        await expect(page).toHaveSimilarURL("${event.value}")
      })
      `
    }
    return ''
  },
};

export default navigation